export default "__VITE_ASSET__B2ORmMCz__"